module.exports = {"short_name":"mobilnet/oz","name":"Obchodny Zastupca","version":"1.6.0","icons":[{"src":"favicon.ico","sizes":"64x64 32x32 24x24 16x16","type":"image/x-icon"}],"start_url":"./index.html","display":"standalone","theme_color":"#000000","background_color":"#ffffff","config":{"baseURI":"https://administracia.mobilnet.sk/","apiPath":"api/oz"}}


//////////////////
// WEBPACK FOOTER
// ./public/manifest.json
// module id = 596
// module chunks = 4